import Header from './components/Header';
import Hero from './components/Hero';
import RankingSection from './components/RankingSection';
import IndexSection from './components/IndexSection';
import AppSection from './components/AppSection';
import FeaturesSection from './components/FeaturesSection';
import CardsSection from './components/CardsSection';
import MediaSection from './components/MediaSection';
import UpdatesSection from './components/UpdatesSection';
import CarouselSection from './components/CarouselSection';
import CommentsSection from './components/CommentsSection';
import ContactSection from './components/ContactSection';
import FAQSection from './components/FAQSection';
import TopicsSection from './components/TopicsSection';
import AboutSection from './components/AboutSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-cinema-bg text-cinema-text">
      <Header />
      <main>
        <Hero />
        <RankingSection />
        <IndexSection />
        <AppSection />
        <FeaturesSection />
        <CardsSection />
        <MediaSection />
        <UpdatesSection />
        <CarouselSection />
        <CommentsSection />
        <ContactSection />
        <FAQSection />
        <TopicsSection />
        <AboutSection />
      </main>
      <Footer />
    </div>
  );
}